module.exports = __webpack_public_path__ + "img/CasinoChangeName_5f8b697878efac1033a311066e92c78f_20211014002435.a072fd37.jpg";